import { session$ } from '../store'
import type { Session, SessionPort, User } from '../domain/auth'

const sessionAdapter: SessionPort = {
	get(): Session | null {
		return session$.get()
	},
	set(session: Session | null): void {
		session$.set(session)
	},
	patchUser(patch: Partial<User>): void {
		const current = session$.get()
		if (!current) return
		session$.set({ user: { ...current.user, ...patch } })
	},
}

export { sessionAdapter }
